import * as React from 'react'

import { IconButton, PanelLeftOpenIcon } from '@buffer-mono/popcorn'

type OpenPostsPanelButtonProps = {
  onClick: () => void
}

export const OpenPostsPanelButton = React.forwardRef<
  HTMLButtonElement,
  OpenPostsPanelButtonProps
>(function OpenPostsPanelButton({ onClick }, ref) {
  return (
    <IconButton
      ref={ref}
      label="Open posts panel"
      variant="secondary"
      onClick={onClick}
    >
      <PanelLeftOpenIcon />
    </IconButton>
  )
})
